/**
 * All the Dealers Microsites's page names.
 */
export const PAGE_NAMES = {
  PAGE_NOT_FOUND: 'page_not_found',
  getDealerCenterPageName: pageCategory => `dealercenter${pageCategory ? `_${pageCategory}` : ''}`,
};

export const DEALER_CENTER_PAGE_NAME = PAGE_NAMES.getDealerCenterPageName();
export const DEALER_CENTER_LEGAL_PAGE_NAME = PAGE_NAMES.getDealerCenterPageName('legal');
export const DEALER_CENTER_PRODUCTS_PAGE_NAME = PAGE_NAMES.getDealerCenterPageName('products');
